// require('./common/_tinySlider.js');
// require('./common/_magnificPopup.js');
// require('./common/_blazy.js');
// require('./common/_objectFit.js');
// require('./common/_filterGrid.js');
// require('./common/_scrolly.js');
// require('./common/_juicer.js');
// require('./common/_smoothScrolling.js');
// require('./common/_tabs.js');
// require('./common/_teamMembers.js');
// require('./common/_mailList.js');
// require('./common/_rangeSlider.js');
// require('./common/_searchNav.js');

import toggler from "./common/_toggler";
import blazy from "./common/_blazy.js";
import tinySlider from "./common/_tinySlider.js";
import objectfit from "./common/_objectFit.js";
import mailList from "./common/_mailList.js";
import searchNav from "./common/_searchNav.js";
import scrolly from "./common/_scrolly.js";
import tabs from "./common/_tabs.js";
import smoothScroll from "./common/_smoothScrolling";
import filter from "./common/_filterGrid";
import juicer from "./common/_juicer";
import teamMembers from "./common/_teamMembers.js";
import glightbox from "./common/_glightbox";
import hidden from "./common/_hidden";
import button from "./common/_button";
import anchor from "./common/_anchor";
import swiper from "./common/_swiper";

document.addEventListener("DOMContentLoaded", () => {
    toggler();
    blazy();
    tinySlider();
    objectfit();
    mailList();
    searchNav();
    scrolly();
    tabs();
    smoothScroll();
    filter();
    juicer();
    teamMembers();
    glightbox();
    hidden();
    button();
    anchor();
    swiper();
});
